
import React from 'react';
import { Task } from '@/context/TaskContext';
import FloatingActionButtons from '@/components/ui/floating-action-buttons';

interface TaskListModalFABsProps {
  isOpen: boolean;
  isAuthenticated: boolean;
  activeListId: string | null;
  activeTask: Task | null;
  mainTab: string;
  showPriorityMatrix: boolean;
  onCreateTask: () => void;
  onStartFocus: () => void;
}

const TaskListModalFABs: React.FC<TaskListModalFABsProps> = ({
  isOpen,
  isAuthenticated,
  activeListId,
  activeTask,
  mainTab,
  showPriorityMatrix,
  onCreateTask,
  onStartFocus
}) => {
  // Show FABs only when in "tasks" tab and not priority matrix
  const canShowFAB = mainTab === 'tasks' && activeListId && !showPriorityMatrix;

  // If not authenticated, modal closed, or not on list tab, hide
  if (!isAuthenticated || !isOpen || !canShowFAB) {
    return null;
  }

  // Smart FAB mode: If a task is selected, show split FAB, else just create
  const splitMode = !!activeTask;

  const handleStartFocus = () => {
    console.log('TaskListModalFABs: Start focus handler called');
    onStartFocus();
  };

  return (
    <FloatingActionButtons
      onCreateTask={onCreateTask}
      onStartFocus={handleStartFocus}
      showStartFocus={!!activeTask}
      splitMode={splitMode}
    />
  );
};

export default TaskListModalFABs;
